import * as React from 'react';

import { useClearDiagram } from 'src/containers/ProjectDiagram/hooks/useClearDiagram';
import { useDiagram } from 'src/containers/ProjectDiagram/hooks/useDiagramValue';
import { ExtendedDiagram } from 'src/containers/ProjectDiagram/templates/extensions/diagram';
import { Resource } from 'src/containers/ProjectDiagram/types/data';
import { addDeletedData } from 'src/containers/ProjectDiagram/utils/addDeletedData';
import { commitDiagramModel } from 'src/containers/ProjectDiagram/utils/commitDiagramModel';
import { isResource } from 'src/containers/ProjectDiagram/utils/data';
import { removeResource } from 'src/containers/ProjectDiagram/utils/resource/removeResource';
import { uiSlice } from 'src/store/ui/ui.slice';
import { useReduxDispatch } from 'src/utils/hooks/useReduxDispatch';
import { useRouterParams } from 'src/utils/hooks/useRouterParams';

export const useRemoveResource = () => {
  const { projectId } = useRouterParams();
  const diagram = useDiagram();
  const clearDiagram = useClearDiagram();
  const dispatch = useReduxDispatch();

  return React.useCallback(
    async ({
      diagram: commitDiagram,
      key,
    }: {
      diagram?: ExtendedDiagram;
      key: string;
    }) => {
      const diagramToUse = commitDiagram || diagram;
      if (!diagramToUse) {
        return;
      }
      const nodeData = diagramToUse.model.nodeDataArray.find(
        (nodeData): nodeData is Resource =>
          isResource(nodeData) && nodeData.key === key
      );

      if (!nodeData) {
        return;
      }

      clearDiagram();

      const didCommit = await commitDiagramModel(
        diagramToUse,
        (model) => {
          if (!commitDiagram) {
            addDeletedData([nodeData])(model);
          }
          removeResource(nodeData)(model);
        },
        {
          shouldCommit: !commitDiagram,
        }
      );

      if (didCommit) {
        dispatch(
          uiSlice.actions.removedKeysFromEntityDrawerHistory({
            projectId,
            entityValues: [nodeData.value],
          })
        );
      }
    },
    [clearDiagram, diagram, dispatch, projectId]
  );
};
